import { useState, useRef, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import AffiliateAccount from 'src/shared/Registration/DualCoverage/AffliliateAccount';
import { BackAvatarSVG } from 'src/Admin/img/GlobalSVG';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MultiStepProgressBar from './MultiStepProgressBar';
import AffiliateCoverage from './AffiliateCoverage';
import ToastMessage from '../common/ToastMessage';
import { toast, ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import { getMemberDetailsByOidAndType } from 'src/redux/admin/api-calls/members';
import UserDefinedLabels from 'src/Admin/utils/UserDefinedLabels';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';

const DashboardAffiliateAccount = (props) => {
  const pageInfo = useRef(null);
  const location = useLocation();
  const { DefaultMemberIDKey } = UserDefinedLabels();
  console.log('debug=>locState', location?.state);

  const dummydualCoverageData = [
    {
      firstName: 'Travis',
      lastName: 'Head',
      employer: 'United Health Group',
      status: 'Active',
      userType: 'Member',
      effectiveDate: '05-01-2023',
      terminationDate: 'NA',
      oid: 'dc1',
    },
    {
      firstName: 'Travis',
      lastName: 'Head',
      employer: 'Strive Company Inc.',
      status: 'Cobra',
      userType: 'Member',
      effectiveDate: '05-01-2023',
      terminationDate: 'NA',
      oid: 'dc2',
    },
    {
      firstName: 'Travis',
      lastName: 'Head',
      employer: 'Mars Company Group',
      status: 'Terminated',
      userType: 'Member',
      effectiveDate: '05-01-2023',
      terminationDate: '06-02-204',
      oid: 'dc3',
    },
  ];
  const [dualCoverageData, setDualCoverageData] = useState(
    dummydualCoverageData,
  );
  const [selectedDualCoverageOption, setSelectedDualCoverageOption] =
    useState(null);

  const [currentStep, setCurrentStep] = useState(1);

  //For Radio Button
  //const [isDefaultMemberType, setIsDefaultMemberType] = useState(true);
  const [isDefaultMemberIdType, setIsDefaultMemberIdType] = useState(true);

  //For SelectionType
  const [memberId, setMemberId] = useState('');
  const [ssnValue, setSsnValue] = useState('');

  const handleDefaultSelectionType = () => {
    setIsDefaultMemberIdType(!isDefaultMemberIdType);
  };

  const handleSearchButton = () => {
    fetchMemberApprovalRequestAvailable();
  };

  const backButtonHandler = (afterSuccess = false) => {
    if (currentStep === 1) {
      //Do nothing
    } else {
      setCurrentStep(1);
      if (afterSuccess) {
        setSsnValue('');
        setMemberId('');
      }
    }
  };

  const onSelectHandler = (e, item) => {
    const selectedDualCoverage =
      dualCoverageData &&
      dualCoverageData.map((coverage) =>
        coverage.oid === item.oid
          ? { ...coverage, isSelected: e.target.checked }
          : coverage,
      );
    setDualCoverageData(selectedDualCoverage);
    const selectedCoverage = selectedDualCoverage.filter(
      (item) => item.isSelected === true,
    );
    setSelectedDualCoverageOption(selectedCoverage);
  };

  const onDualCoverageRadioChange = (e, item) => {
    dualCoverageData &&
      dualCoverageData.map(
        (coverage) =>
          coverage.oid === item.oid && setSelectedDualCoverageOption(item),
      );
  };

  useEffect(() => {
    setTimeout(() => {
      if (pageInfo && pageInfo.current) {
        pageInfo.current.focus();
      }
    }, 10);
  }, []);

  const fetchMemberDetails = async (memberData) => {
    try {
      //Use Promise.all to fetch all member details concurrently
      const responses = await Promise.all(
        memberData?.map(async ({ memberOid, memberType }) => {
          //Fetch member details using the first API
          const memberDetailsResponse = await getMemberDetailsByOidAndType(
            memberOid,
            memberType,
            true,
          );

          //Check if the response status is not 200 and throw an error
          if (
            memberDetailsResponse.status !=
            HttpSuccessCodes?.HTTP_SUCCESS_CODE_200
          ) {
            throw new Error(
              `Member Details API failed for memberOid: ${memberOid} with status: ${memberDetailsResponse?.status}`,
            );
          }

          //Combine both responses into a single structured data object
          const memberData = memberDetailsResponse?.data?.Response?.Member;

          //memberData.ClientOid = clientOid;

          const structuredData = {
            FirstName: memberData?.FirstName || '',
            LastName: memberData?.LastName || '',
            BirthDate: memberData?.BirthDate || '',
            CertificateNumber:
              memberData?.CertificateNumber ||
              memberData?.Certificatenumber ||
              '',
            AlternateID1: memberData?.AlternateID1 || '',
            AlternateID2: memberData?.AlternateID2 || '',
            SSN: memberData?.SocialSecurityNumber || '',
            CellPhone: memberData?.ContactDetails?.PhoneEmail?.[0]?.CellPhone1,
            EmailAddress:
              memberData?.ContactDetails?.PhoneEmail[0]?.EmailAddress,
            ContactDetails: memberData?.ContactDetails || {},
            //ClientOid: clientOid || '', //Include ClientOid
            MemberOid: memberOid,
            memberDetailsResp: memberDetailsResponse?.data,
          };

          return structuredData;
        }),
      );
      return responses;
    } catch (error) {
      console.error('Error fetching member details:', error);
      return null;
    }
  };

  const validateMemberDetails = async () => {
    try {
      const payload = {
        FirstName: location?.state?.userDataRedux?.FirstName,
        LastName: location?.state?.userDataRedux?.LastName,
        //BirthDate: userDetails?.DateofBirth,
        UserType: location?.state?.userDataRedux?.UserType,
        IsRegistration: true,
      };
      if (isDefaultMemberIdType === true) {
        if (DefaultMemberIDKey === 'CertificateNumber') {
          payload['CertificateNumber'] = memberId;
        } else if (DefaultMemberIDKey === 'AlternateID1') {
          payload['AlternateID1'] = memberId;
        } else if (DefaultMemberIDKey === 'AlternateID2') {
          payload['AlternateID2'] = memberId;
        } else if (DefaultMemberIDKey === 'alternateID1') {
          console.log('debug_payload', payload);

          payload['AlternateID1'] = memberId;
        } else if (DefaultMemberIDKey === 'alternateID2') {
          payload['AlternateID2'] = memberId;
        } else {
          payload[DefaultMemberIDKey] = memberId;
        }
      } else {
        payload['SocialSecurityNumber'] = ssnValue;
      }
      console.log('debug_payload', payload);
      //Decrypt the response
      const response = await axiosInstance.post(
        APIEndpoints.dualCoverageValidateMemberInfoNewResources(),
        payload,
      );

      //Decrypt the response
      const data = response?.data;

      if (response?.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201) {
        const usersData = [];
        if (data?.Response) {
          const { MemberResponse = [], DependentResponse = [] } = data.Response;

          //Process MemberResponse
          MemberResponse?.forEach((item) =>
            usersData.push({
              memberOid: item?.MemberOid,
              memberType: 'Employee',
            }),
          );

          //Process DependentResponse
          DependentResponse?.forEach((item) =>
            usersData.push({
              memberOid: item?.DependentOid,
              memberType: 'Dependent',
            }),
          );

          if (usersData?.length) {
            const resp = fetchMemberDetails(usersData);
            resp
              .then((response) => {
                const formattedDualCoverageData = response?.map((item) => {
                  const memberDetails =
                    item?.memberDetailsResp?.Response?.Member;
                  const dependentDetails =
                    item?.memberDetailsResp?.Response?.Dependent;
                  const coverageData = {
                    firstName: memberDetails?.FirstName,
                    lastName: memberDetails?.LastName,
                    employer: memberDetails?.ClientName,
                    status:
                      item?.memberDetailsResp?.Response?.MemberType ===
                      'Dependent'
                        ? item?.memberDetailsResp?.Response
                            ?.DependentsInformation?.Status
                        : item?.memberDetailsResp?.Response?.MemberInformation
                            ?.Status,
                    userType: item?.memberDetailsResp?.Response?.MemberType,
                    oid: memberDetails?.OID,
                    DualCoverageEffectiveDate:
                      item?.memberDetailsResp?.Response?.MemberType ===
                      'Dependent'
                        ? item?.memberDetailsResp?.Response
                            ?.DependentsInformation?.DependentDCEffectiveDate
                        : item?.memberDetailsResp?.Response?.MemberInformation
                            ?.DualCoverageEffectiveDate,
                    DualCoveragTerminationDate:
                      item?.memberDetailsResp?.Response?.MemberType ===
                      'Dependent'
                        ? item?.memberDetailsResp?.Response
                            ?.DependentsInformation?.DependentDCTerminationDate
                        : item?.memberDetailsResp?.Response?.MemberInformation
                            ?.DualCoveragTerminationDate,
                    details: item,
                  };
                  return coverageData;
                });
                if (formattedDualCoverageData) {
                  setDualCoverageData(formattedDualCoverageData);
                  setCurrentStep(2);
                  setTimeout(() => {
                    if (pageInfo && pageInfo.current) {
                      pageInfo.current.focus();
                    }
                  }, 10);
                }
              })
              .catch((error) => {
                console.log('error message: ', error.message);
              });
          } else {
            console.log('error message: No Data for affiliate account');
          }
        }
      } else {
        console.log('debug_resp', response);
        toast.error(
          <ToastMessage
            type="error"
            subTitle="We are unable to validate your user information now. Please try again later."
          />,
        );
      }
    } catch (error) {
      console.log('field data not sent: ', error);
      if (error?.response?.status == 409) {
        console.log('error message: ', error.message);
        toast.error(
          <ToastMessage
            type="error"
            subTitle="There is no record(s) available for affiliation."
          />,
        );
      } else {
        console.log('error message: ', error.message);
        toast.error(
          <ToastMessage
            type="error"
            subTitle="We are unable to validate your user information now. Please try again later."
          />,
        );
      }
    }
  };

  const fetchMemberApprovalRequestAvailable = async () => {
    try {
      const oid = location?.state?.userDataRedux?.Oid;
      const response = await axiosInstance.get(
        APIEndpoints.isApprovalRequestPendingForMemberResource() + oid,
      );
      console.log('debug_response', response);
      if (
        response?.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response?.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        validateMemberDetails();
      }
    } catch (error) {
      console.log('debug_error: ', error);
      if (error?.response?.status === 400) {
        toast.info(
          <ToastMessage
            type="info"
            title="A request for account affiliation is already pending."
            subTitle="Please verify the status of the existing request before continuing."
          />,
        );
      } else {
        toast.error(
          <ToastMessage
            type="error"
            subTitle="We are unable to validate your user information now. Please try again later."
          />,
        );
      }
    }
  };
  console.log('DualCoverage dualCoverageData', dualCoverageData);

  return (
    <div className="p-4 affiliate-account-container">
      <Container>
        <div className="d-flex flex-row align-items-center">
          <div className="pr-4">
            <Link
              aria-label="back button"
              to={`${
                currentStep === 1
                  ? '/admin/member-management'
                  : '/admin/affiliate-account'
              } `}
              state={
                currentStep === 1
                  ? {
                      ...location.state,
                    }
                  : {
                      ...location.state,
                      userDataRedux: location?.state?.userDataRedux,
                    }
              }
              onClick={backButtonHandler}
            >
              <div>
                <BackAvatarSVG.BackArrowSVG />
              </div>
            </Link>
          </div>
          <div
            className="register-header"
            role="heading"
            aria-level={1}
            tabIndex={0}
            ref={pageInfo}
          >
            Affiliate Account
          </div>
        </div>
        <div aria-hidden="true">
          <MultiStepProgressBar currentStep={currentStep} />
        </div>
        {currentStep === 1 && (
          <AffiliateAccount
            //isDefaultMemberType={isDefaultMemberType}
            //handleDefaultUserType={handleDefaultUserType}
            isDefaultMemberIdType={isDefaultMemberIdType}
            handleDefaultSelectionType={handleDefaultSelectionType}
            ssnValue={ssnValue}
            setSsnValue={setSsnValue}
            memberId={memberId}
            setMemberId={setMemberId}
            handleSearchButton={handleSearchButton}
          />
        )}
        {currentStep === 2 && (
          <AffiliateCoverage
            data={dualCoverageData}
            onSelectHandler={onSelectHandler}
            onDualCoverageRadioChange={onDualCoverageRadioChange}
            selectedDualCoverageOption={selectedDualCoverageOption}
            multiSelect={true}
            backHandler={backButtonHandler}
            userDataRedux={location?.state?.userDataRedux || {}}
          />
        )}
      </Container>
      {/*<div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className="affiliate-account-toaster-container"
        />
      </div> */}
    </div>
  );
};

export default DashboardAffiliateAccount;
